import { Component, EventEmitter, Input, Output } from '@angular/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HelpService } from './help.service';
import { HelpArticleSummary } from './models/help-article.model';

/**
 * Search results for a query. Navigation-agnostic — emits [openArticle]. The host owns the search box
 * and feeds the query in via [query].
 */
@Component({
  selector: 'ee-help-search',
  templateUrl: './help-search.component.html',
  styleUrls: ['./help-search.component.scss'],
  standalone: false,
})
export class HelpSearchComponent {
  @Output() openArticle = new EventEmitter<string>();

  loading = false;
  searched = false;
  results: HelpArticleSummary[] = [];

  private current = '';

  @Input()
  set query(value: string) {
    this.current = value ?? '';
    this.run();
  }

  get query(): string {
    return this.current;
  }

  constructor(private helpService: HelpService) {}

  private run(): void {
    if (!this.current.trim()) {
      this.results = [];
      this.searched = false;
      this.loading = false;
      return;
    }
    this.loading = true;
    this.searched = true;
    this.helpService
      .search(this.current)
      .pipe(catchError(() => of([] as HelpArticleSummary[])))
      .subscribe((results) => {
        this.results = results;
        this.loading = false;
      });
  }
}
